module.exports = __webpack_public_path__ + "static/media/headr-article-img@2x.b2489dee.png";